import { createSlice } from "@reduxjs/toolkit";

// Filtros de la navegabilidad de evaluaciones.
const initialState = {
    filters: {
        idFilial: 0,
        member: "",
        fechaInicio: "",
        fechaFin: "",
        idEstado: 0,
    },
}

export const evaluacionSearchSlice = createSlice({
    name: "evaluacionSearch",
    initialState,
    reducers: {
        setValue: (state, action) => {
            var { name, value } = action.payload;

            state[name] = value
        },
    },
});

export const { setValue } = evaluacionSearchSlice.actions;
export default evaluacionSearchSlice.reducer;
